export default __webpack_public_path__ + "static/media/img1.ec9c8407.jpg";